import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Valuedrivenios() {
  return (
    <section
      className="valuedriven_ios p-100"
      style={{ background: "#F6F6F6" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} className="my-auto">
            <h3 className="h3_head">
              What Makes Our iOS App Development Services Value-Driven?
            </h3>
            <p>
              TekRevol’s iOS app development service is for businesses of all
              sizes – a strategic advantage for growth-enabled tech
              transformation. With deep expertise and novel technologies like
              Swift, SwiftUI, and Core Data build highly performant and scalable
              Apple apps.
            </p>
            <p>
              We follow Agile methodologies and DevOps practices for rapid
              development cycles, continuous integration, and upscale to create
              fast and secure apps. Our top-tier iOS app developers and QA
              engineers rigorously test each component for flawless
              functionality across Apple devices.
            </p>
            <p>
              Our focus on user-centric design and advanced UX/UI frameworks
              like UIKit and ARKit enables immersive and engaging experiences.
              From small businesses to enterprises, our iOS app development
              company is keen to drive customer engagement, business growth, and
              transformation.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            className="my-auto offset-lg-1 mt-3 mt-md-0 text-center"
          >
            <StaticImage
              src="../../images/services-usa/iphone-new/value_mob_ios.webp"
              alt="tekrevol_web"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={686}
              height={782}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Valuedrivenios;
